import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { hasCookie } from 'services/actions/cookies_actions';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { BiddingData } from 'store/modules/bidding_store/types';
import {
  clearFormQuote,
  getFidelizeBiddingGuarantee,
  setOriginChannel,
} from 'store/modules/conlicitaseg_store/actions';
import createTrack from 'services/actions/tracker_actions';
import { formatCurrency } from 'services/conlicitaseg';
import { Container } from './styles';

const ConlicitasegModalFidelizeTester: React.FC = () => {
  const [show, setShow] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  useEffect(() => {
    if (!hasCookie('ConlicitasegModalFidelizeTester') && profile?.fidelize?.is_fidelize) {
      setShow(true);
    }
  }, []);

  const handleClose = () => {
    createTrack('ConlicitaSeg - Fechou modal', {
      fonte: 'Modal Fidelize Tester',
    });
    setShow(false);
  };

  const handleStartNow = (bidding: BiddingData) => {
    dispatch(clearFormQuote());
    // Mesmo pré-preenchimento do login, mas sem marcar os campos.
    dispatch(getFidelizeBiddingGuarantee(bidding, profile, { markAutofill: false }));
    dispatch(setOriginChannel('fidelize'));
    setShow(false);
    createTrack('ConlicitaSeg - Clicou no botão cotar garantia', {
      fonte: 'Modal Fidelize Tester',
    });
    history.push('/conlicitaseg/novo', { prefilled: true });
  };

  const handleRemindLater = () => {
    const expires = new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `ConlicitasegModalFidelizeTester=true;path=/;expires=${expires}`;
    createTrack('ConlicitaSeg - Lembrar mais tarde', {
      fonte: 'Modal Fidelize Tester',
    });
    setShow(false);
  };

  const biddings = profile?.fidelize?.biddings ?? [];

  const totalBiddings = biddings?.length;

  return (
    <Modal show={show} onHide={handleClose} centered size="xl" backdrop="static">
      <Container>
        <button type="button" className="close-button" onClick={handleClose} aria-label="Fechar">
          <i className="material-icons">close</i>
          <span className="ml-2">Fechar</span>
        </button>

        <div className="modal-content-wrapper">
          <div className="d-flex align-items-center justify-content-center">
            <div className="celebration-icon">🎉</div>
            <h2 className="title">Parabéns {profile?.name}!</h2>
          </div>
          <p className="fs-5 mb-0">
            Verificamos que a {profile?.company_data?.data?.razao_social} venceu{' '}
            <strong>
              [{totalBiddings}]{totalBiddings === 1 ? ' nova oportunidade' : ' novas oportunidades'}{' '}
            </strong>{' '}
            com o governo:
          </p>
          <p className="fs-6">
            Como {totalBiddings === 1 ? 'esse contrato exige' : 'esses contratos exigem'} garantia
            de execução, convidamos você a utilizar agora mesmo o ConlicitaSeg, serviço online de
            cotação e emissão de apólices do ConLicitação.
          </p>

          {biddings.map((bidding) => {
            const biddingValue = formatCurrency(bidding?.valor, { emptyOnZero: true });
            return (
              <div key={bidding?.id} className="edital-card">
                <div className="edital-info">
                  <p className="mb-0">
                    <strong>Edital</strong> {bidding?.edital}
                  </p>
                  <p className="mb-0">
                    <strong>Órgão</strong> {bidding?.public_body?.nome}
                  </p>
                  {biddingValue && (
                    <p className="mb-0">
                      <strong>Valor Homologado</strong> {biddingValue}
                    </p>
                  )}
                </div>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => handleStartNow(bidding)}
                >
                  Cotar minha garantia
                </button>
              </div>
            );
          })}

          <button
            type="button"
            className="btn btn-link link-primary text-decoration-none"
            onClick={handleRemindLater}
          >
            Lembre-me mais tarde
          </button>
        </div>
      </Container>
    </Modal>
  );
};

export default ConlicitasegModalFidelizeTester;
